import { useMemo, useState } from "react";
import classes from "./OverallStudentAnalysis.module.css";
import Search from "./Search";
import Pagination from "./Pagination";
import data from "./data.json";
import { Table } from "react-bootstrap";
import { isEmpty } from "../../utils/custom_funtions";

const OverallStudentAnalysis = () => {
    const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [showEntries, setShowEntries] = useState(10);
  const ITEMS_PER_PAGE = +showEntries;
  const commentsData = useMemo(() => {
    let computedComments = data;

    if (search) {
      computedComments = computedComments.filter((comment) =>
        comment.student_name.toLowerCase().includes(search.toLowerCase()) ||
        comment.roll_no.toLowerCase().includes(search.toLowerCase()) 
      );
    }

    setTotalItems(computedComments.length);
    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [data, currentPage, search, ITEMS_PER_PAGE]);

  return (
    <>
      <div className={classes.head}>
        <p className={classes.heading}>Overall Student Analysis</p>
        <Search
          onSearch={(value) => {
            setSearch(value);
            setCurrentPage(1);
          }}
        />
      </div>
      <div className={classes.line}></div>
      <div className={classes.section}>
      <div className="mb-2">
          Show{" "}
          <select
          value={showEntries}
            onChange={(e) => {
              setShowEntries(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="20">20</option>
          </select>{" "}
          enteries
        </div>
        <Table responsive bordered className={classes.table}>
          <thead className={classes.header}>
            <tr>
              <th rowSpan={2}>Student Name</th>
              <th rowSpan={2}>Roll No</th>
              <th rowSpan={1} colSpan={3}>
                <p className={classes.subHeading}>Marks Obtained</p>
              </th>
              <th rowSpan={2}>Overall Rank</th>
            </tr>
            <tr>
            <th rowSpan={1}>Physics</th>
            <th rowSpan={1}>Chemistry</th>
            <th rowSpan={1}>Maths</th>
            </tr>
          </thead>
          <tbody>
            {isEmpty(commentsData) && !isEmpty(search) && (
              <tr>
                <td colSpan={6}>No data found !!</td>
              </tr>
            )}
            {commentsData.map((data, index) => (
              <tr>
                <td>{data.student_name}</td>
                <td className={classes.qid}>{data.roll_no}</td>
                <td>{data.physics_marks}</td>
                <td>{data.chemisry_marks}</td>
                <td>{data.maths_marks}</td>
                <td>{data.overall_rank}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <p className="small ">
        Showing{" "}
        <b>
          {+showEntries < data.length
            ? +showEntries
            : data.length}
        </b>{" "}
        out of {data.length} enteries
      </p>
        <div className="mt-2">
          <Pagination
            total={totalItems}
            itemsPerPage={ITEMS_PER_PAGE}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
      </div>
    </>
  );
}

export default OverallStudentAnalysis